import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "section-container background-gray q-py-lg" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "q-py-lg bg-white" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "q-mt-xs" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "reward_amount" }
const _hoisted_10 = { class: "q-ml-sm" }
const _hoisted_11 = {
  key: 0,
  style: {},
  class: "question"
}
const _hoisted_12 = ["alt", "src"]
const _hoisted_13 = ["alt", "src"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  class: "col-12 q-py-lg q-px-md",
  style: {"border-top":"1px solid var(--border-color)"}
}
const _hoisted_16 = { class: "flex items-center q-col-gutter-md row" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "col-6 text-weight-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "label q-mr-md" }, "Payout:", -1)
const _hoisted_23 = {
  class: "reward_amount",
  style: {"margin-right":"32px"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "label q-mr-md" }, "Conversion type:", -1)
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "label q-mr-md" }, "Geo:", -1)
const _hoisted_31 = ["alt", "src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_33 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuperOffers = _resolveComponent("SuperOffers")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_CampaignEditDialog = _resolveComponent("CampaignEditDialog")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('offers')), 1),
        _createVNode(_component_SuperOffers)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Filters, {
          onReset: _ctx.resetFilters,
          onChange: _ctx.onChangeFilters,
          onChangeAll: _ctx.changeAll,
          "current-filters": _ctx.filters
        }, null, 8, ["onReset", "onChange", "onChangeAll", "current-filters"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_table, {
          id: "offers-table",
          rows: _ctx.rows,
          columns: _ctx.columns,
          "card-container-class": "grid-masonry grid-masonry--3",
          "rows-per-page-options": [25, 50, 100],
          grid: _ctx.$q.screen.width <= 1023,
          "row-key": "id",
          flat: "",
          "table-header-class": 
          _ctx.rows.length && _ctx.rows[0].borderColor ? 'offers-header' : ''
        ,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
          loading: _ctx.loading,
          onRequest: _ctx.onRequest,
          onRowClick: _ctx.onRowClick,
          "binary-state-sort": "",
          "rows-per-page-label": _ctx.$t('rows_per_page'),
          "icon-prev-page": _ctx.heroOutline24ChevronLeft,
          "icon-next-page": _ctx.heroOutline24ChevronRight
        }, _createSlots({ _: 2 }, [
          (_ctx.$q.screen.width >= 1024)
            ? {
                name: "body",
                fn: _withCtx((props) => [
                  _createVNode(_component_q_tr, {
                    style: _normalizeStyle(
              props.row.borderColor && props.row.borderLabel
                ? `border: 2px solid ${props.row.borderColor} !important;`
                : ''
            )
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "logo",
                        style: {"position":"relative"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            target: "_blank",
                            class: "flex column",
                            href: 'https://affiliate.gambeat.io/offers/' + props.row.id
                          }, [
                            _createElementVNode("img", {
                              width: "100",
                              height: "50",
                              src: `${_ctx.storageUrl + '/' + props.row.image}`
                            }, null, 8, _hoisted_6)
                          ], 8, _hoisted_5)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "name",
                        style: {"position":"relative"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(props.row.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "amount"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getRewardAmounts([
                      ...props.row.commonRewards,
                      ...props.row.affiliateRewards,
                    ])), 1),
                            _createElementVNode("div", _hoisted_10, [
                              (
                      [
                        ...props.row.commonRewards,
                        ...props.row.affiliateRewards,
                      ].length > 1
                    )
                                ? (_openBlock(), _createElementBlock("sup", _hoisted_11, "?"))
                                : _createCommentVNode("", true),
                              (
                      [
                        ...props.row.commonRewards,
                        ...props.row.affiliateRewards,
                      ].length > 1
                    )
                                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                    key: 1,
                                    anchor: "top right",
                                    self: "top right",
                                    class: "q-tooltip custom-tooltip"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getRewards([
                        ...props.row.commonRewards,
                        ...props.row.affiliateRewards,
                      ])), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "geo"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGeos(props.row, true), (geo, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex"
                            }, [
                              _createElementVNode("span", null, [
                                _createElementVNode("img", {
                                  class: "q-mr-sm",
                                  height: "10",
                                  width: "15",
                                  alt: props.row.geo,
                                  src: 
                      `http://purecatamphetamine.github.io/country-flag-icons/3x2/${geo.isoCode}.svg`
                    
                                }, null, 8, _hoisted_12),
                                _createTextVNode(_toDisplayString(geo.name), 1)
                              ])
                            ]))
                          }), 128)),
                          (_ctx.getGeos(props.row).length > 3)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                onClick: _withModifiers(($event: any) => (true), ["stop"]),
                                size: "sm",
                                flat: "",
                                "no-caps": "",
                                push: "",
                                label: _ctx.$t('show_more')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_popup_proxy, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_banner, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGeos(props.row), (geo, key) => {
                                            return (_openBlock(), _createElementBlock("div", { key: key }, [
                                              _createElementVNode("span", null, [
                                                (geo.isoCode)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      class: "q-mr-sm",
                                                      height: "10",
                                                      width: "15",
                                                      alt: props.row.geo,
                                                      src: 
                            `http://purecatamphetamine.github.io/country-flag-icons/3x2/${geo.isoCode}.svg`
                          
                                                    }, null, 8, _hoisted_13))
                                                  : _createCommentVNode("", true),
                                                _createTextVNode(_toDisplayString(geo.name), 1)
                                              ])
                                            ]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "label"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "rewardType"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRewardTypes(props.row), (type, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("span", { innerHTML: type }, null, 8, _hoisted_14)
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        props: props,
                        key: "actions"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_btn, {
                            "no-caps": "",
                            outline: "",
                            label: "Open details",
                            class: "q-btn__main-size q-mr-md text-weight-bold",
                            color: "gray",
                            onClick: ($event: any) => (_ctx.openInNewTab(props.row))
                          }, null, 8, ["onClick"]),
                          (
                  _ctx.hasAccess(
                    props.row.offersAccess && props.row.offersAccess.status,
                  )
                )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                "no-caps": "",
                                color: "primary",
                                class: "q-btn__main-size text-weight-bold",
                                unelevated: "",
                                label: _ctx.$t('create_campaign'),
                                onClick: _withModifiers(($event: any) => (_ctx.createCampaign(props.row.id)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    size: "16px",
                                    style: {"margin-left":"10px"},
                                    name: _ctx.heroOutline24ArrowLongRight
                                  }, null, 8, ["name"])
                                ]),
                                _: 2
                              }, 1032, ["label", "onClick"]))
                            : (_openBlock(), _createBlock(_component_q_btn, {
                                key: 1,
                                "no-caps": "",
                                color: "primary",
                                unelevated: "",
                                class: "q-btn__main-size text-weight-bold",
                                disable: !!props.row.offersAccess,
                                label: 
                  props.row.offersAccess ? _ctx.$t('had_access') : _ctx.$t('access')
                ,
                                onClick: _withModifiers(($event: any) => (_ctx.getAccess(props.row.id)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    size: "16px",
                                    style: {"margin-left":"10px"},
                                    name: _ctx.heroOutline24ArrowLongRight
                                  }, null, 8, ["name"])
                                ]),
                                _: 2
                              }, 1032, ["disable", "label", "onClick"]))
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["style"])
                ]),
                key: "0"
              }
            : undefined,
          (_ctx.$q.screen.width <= 1024)
            ? {
                name: "item",
                fn: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        width: "100",
                        height: "50",
                        src: `${_ctx.storageUrl + '/' + props.row.image}`,
                        class: "col",
                        style: {"max-width":"150px"}
                      }, null, 8, _hoisted_17),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(props.row.name), 1)
                    ]),
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, [
                          _createTextVNode(_toDisplayString(_ctx.getRewardAmounts([
                      ...props.row.commonRewards,
                      ...props.row.affiliateRewards,
                    ])) + " ", 1),
                          (
                      [
                        ...props.row.commonRewards,
                        ...props.row.affiliateRewards,
                      ].length > 1
                    )
                            ? (_openBlock(), _createElementBlock("sup", _hoisted_24, "?"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRewardTypes(props.row), (type, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("span", { innerHTML: type }, null, 8, _hoisted_27)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGeos(props.row, true), (geo, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flex q-mr-md"
                        }, [
                          _createElementVNode("span", null, [
                            _createElementVNode("img", {
                              class: "q-mr-sm",
                              height: "10",
                              width: "15",
                              alt: props.row.geo,
                              src: 
                      `http://purecatamphetamine.github.io/country-flag-icons/3x2/${geo.isoCode}.svg`
                    
                            }, null, 8, _hoisted_31),
                            _createTextVNode(_toDisplayString(geo.name), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_q_btn, {
                        "no-caps": "",
                        outline: "",
                        label: "Open details",
                        class: "q-btn__main-size q-mb-sm text-weight-bold full-width",
                        color: "gray",
                        onClick: ($event: any) => (_ctx.openInNewTab(props.row))
                      }, null, 8, ["onClick"]),
                      (
                  _ctx.hasAccess(
                    props.row.offersAccess && props.row.offersAccess.status,
                  )
                )
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            "no-caps": "",
                            color: "primary",
                            class: "q-btn__main-size text-weight-bold full-width",
                            unelevated: "",
                            label: _ctx.$t('create_campaign'),
                            onClick: _withModifiers(($event: any) => (_ctx.createCampaign(props.row.id)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                size: "16px",
                                style: {"margin-left":"10px"},
                                name: _ctx.heroOutline24ArrowLongRight
                              }, null, 8, ["name"])
                            ]),
                            _: 2
                          }, 1032, ["label", "onClick"]))
                        : (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            "no-caps": "",
                            color: "primary",
                            unelevated: "",
                            class: "q-btn__main-size text-weight-bold full-width",
                            disable: !!props.row.offersAccess,
                            label: 
                  props.row.offersAccess ? _ctx.$t('had_access') : _ctx.$t('access')
                ,
                            onClick: _withModifiers(($event: any) => (_ctx.getAccess(props.row.id)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                size: "16px",
                                style: {"margin-left":"10px"},
                                name: _ctx.heroOutline24ArrowLongRight
                              }, null, 8, ["name"])
                            ]),
                            _: 2
                          }, 1032, ["disable", "label", "onClick"]))
                    ])
                  ])
                ]),
                key: "1"
              }
            : undefined
        ]), 1032, ["rows", "columns", "grid", "table-header-class", "pagination", "loading", "onRequest", "onRowClick", "rows-per-page-label", "icon-prev-page", "icon-next-page"])
      ]),
      (_ctx.showCampaignEditDialog)
        ? (_openBlock(), _createBlock(_component_CampaignEditDialog, {
            key: 0,
            open: _ctx.showCampaignEditDialog,
            onClose: _ctx.closeCampaignDialog,
            offerId: _ctx.currentRowId
          }, null, 8, ["open", "onClose", "offerId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}